import { generateMatrix } from '../../helper'
import { icons } from '../../data'


export const arrPopup1 = [
  { text: 'Задание: заменить пиктограммы на числа, которые им соответствуют.', buttonTitle: 'Начать' },
]

export const arrPopup2 = [
  { text: 'Теперь определим, чей профиль максимально похож на профиль Толи по музыкальным интересам за три шага.' },
  // { text: 'Перед тобой таблица реакций пользователей на разные песни. Что означает каждая реакция, ты можешь увидеть в легенде.\n' },
  // { text: 'Так как нам нужно определить рекомендации для Толи, то мы каждую его реакцию умножаем на реакцию каждого другого пользователя по данной песне (т.е. каждую реакцию Толи умножаем на каждую в соответствующем столбце). \n' },
  { text: '1 шаг <br> Задание: найди произведение реакции Толи на реакцию каждого профиля по столбцам и запиши результаты <span class="textBold">в пустое место в ячейке</span>.', buttonTitle: 'Начать' },
]

export const arrPopup3 = [
  // { text: 'Как теперь по полученным числам определить совпадение музыкальных предпочтений профилей? Очень просто! Найти сумму полученных произведений.' },
  { text: '2 шаг <br> Задание: <span class="textBold">вычисли сумму зеленых чисел</span> в каждой строке и запиши результаты справа.', buttonTitle: 'Начать' },
]
export const arrPopup4 = [
  { text: '3 шаг <br> Не всегда можно найти профиль с полностью совпадающими интересами. Определи, чей профиль теперь максимально похож на Толин и имеет ли смысл рекомендовать ему эту песню?', buttonTitle: 'Начать' },
]

export const arrPopup5 = [
  { text: 'Точность рекомендации теперь ниже, но это лучше, чем просто угадывать. Опираясь на данные похожего профиля, стал бы ты рекомендовать Толе песню Юли?', buttonTitle: 'Продолжить' },
]


export const task1 = [
  { text: 'Задание: заменить пиктограммы на числа, которые им соответствуют.' },
]
export const task2 = [
  { text: 'Задание: найди произведение реакции Толи на реакцию каждого профиля по столбцам и запиши результаты <span class="textBold">в пустое место в ячейке</span>.' },
]
export const task3 = [
  { text: 'Задание: <span class="textBold">вычисли сумму зеленых чисел</span> в каждой строке и запиши результаты справа.' },
]
export const task4 = [
  { text: 'Найди профиль с максимальной суммой и выдели его.' },
]
export const task5 = [
  { text: 'Опираясь на данные похожего профиля, стал бы ты рекомендовать Толе песню Юли?' },
]

const matrix1 = [
  {
    name: 'Илон',
    namePretext: 'Илона',
    matrix: ['0', '1', '0', '0', '1', '0', '1'],
    icon: icons.ilon,
  },
  {
    name: 'Егор',
    namePretext: 'Егора',
    icon: icons.egor,
    matrix: ['-1', '0', '1', '0', '10', '-1', '0'],
  },
  {
    name: 'Семен',
    icon: icons.semen,
    matrix: ['0', '0', '-1', '-1', '0', '1', '-10'],
  },
  {
    name: 'Клава',
    namePretext: 'Клавы',
    icon: icons.julia,
    matrix: ['-1', '10', '-1', '1', '0', '-1', '0'],
  },
  {
    icon: icons.luda,
    name: 'Люда',
    namePretext: 'Люды',
    matrix: ['1', '-1', '1', '1', '0', '0', '1'],

  },
  {
    name: 'Толя',
    me: true,
    icon: icons.tolya,
    matrix: ['-1', '0', '?', '-10', '1', '1', '1'],
  },
]
const matrix2 = [
  {
    name: 'Илон',
    namePretext: 'Илона',
    matrix: ['1', '-1', '1', '1', '0', '1', '0'],
    icon: icons.ilon,
  },
  {
    name: 'Егор',
    namePretext: 'Егора',
    icon: icons.egor,
    matrix: ['0', '-1', '1', '0', '0', '1', '-1'],
  },
  {
    name: 'Семен',
    namePretext: 'Семен',
    icon: icons.semen,
    matrix: ['0', '0', '10', '0', '-1', '10', '-10'],
  },
  {
    name: 'Клава',
    namePretext: 'Клавы',
    icon: icons.julia,
    matrix: ['-10', '-1', '0', '10', '-1', '0', '1'],
  },
  {
    icon: icons.luda,
    name: 'Люда',
    namePretext: 'Люды',
    matrix: ['-1', '-1', '0', '10', '1', '0', '0'],

  },
  {
    name: 'Толя',
    me: true,
    icon: icons.tolya,
    matrix: ['1', '0', '10', '0', '10', '0', '?'],
  },
]
const matrix3 = [
  {
    name: 'Илон',
    namePretext: 'Илона',
    matrix: ['1', '0', '0', '1', '-10', '-1', '1'],
    icon: icons.ilon,
  },
  {
    name: 'Егор',
    namePretext: 'Егора',
    icon: icons.egor,
    matrix: ['-1', '0', '-10', '1', '0', '-1', '-10'],
  },
  {
    name: 'Семен',
    namePretext: 'Семена',
    icon: icons.semen,
    matrix: ['-1', '-10', '-1', '0', '1', '0', '0'],
  },
  {
    name: 'Клава',
    namePretext: 'Клавы',
    icon: icons.julia,
    matrix: ['0', '10', '0', '-10', '1', '-1', '10'],
  },
  {
    icon: icons.luda,
    name: 'Люда',
    namePretext: 'Люды',
    matrix: ['0', '0', '-1', '0', '0', '10', '0'],

  },
  {
    name: 'Толя',
    me: true,
    icon: icons.tolya,
    matrix: ['?', '10', '-1', '1', '1', '0', '-10'],
  },
]
export const arrMatrix1 = generateMatrix(matrix1)
export const arrMatrix2 = generateMatrix(matrix2)
export const arrMatrix3 = generateMatrix(matrix3)
